export default __webpack_public_path__ + "arrow-down-on-black-circular-background.png";